// Comprehensive wine regions and appellations by country

export interface RegionData {
  regions: string[];
  appellations: string[];
}

export const WINE_REGIONS: Record<string, RegionData> = {
  'France': {
    regions: ['Alsace', 'Bordeaux', 'Burgundy', 'Champagne', 'Jura', 'Languedoc-Roussillon', 
      'Loire Valley', 'Provence', 'Rhône Valley', 'Savoie', 'Southwest France', 'Corsica'],
    appellations: [
      // Bordeaux
      'Margaux', 'Pauillac', 'Saint-Julien', 'Saint-Estèphe', 'Pessac-Léognan', 'Graves',
      'Pomerol', 'Saint-Émilion', 'Médoc', 'Haut-Médoc', 'Sauternes', 'Barsac', 'Entre-Deux-Mers',
      // Burgundy  
      'Chablis', 'Côte de Nuits', 'Côte de Beaune', 'Côte Chalonnaise', 'Mâconnais',
      'Gevrey-Chambertin', 'Chambolle-Musigny', 'Vosne-Romanée', 'Nuits-Saint-Georges',
      'Pommard', 'Volnay', 'Meursault', 'Puligny-Montrachet', 'Chassagne-Montrachet',
      'Beaune', 'Corton', 'Pouilly-Fuissé', 'Saint-Véran',
      // Rhône
      'Côte-Rôtie', 'Condrieu', 'Hermitage', 'Crozes-Hermitage', 'Saint-Joseph', 'Cornas',
      'Châteauneuf-du-Pape', 'Gigondas', 'Vacqueyras', 'Côtes du Rhône', 'Tavel', 'Lirac',
      // Loire
      'Sancerre', 'Pouilly-Fumé', 'Vouvray', 'Chinon', 'Bourgueil', 'Muscadet', 'Savennières',
      'Anjou', 'Saumur', 'Touraine', 'Montlouis',
      // Champagne
      'Champagne', 'Côte des Blancs', 'Montagne de Reims', 'Vallée de la Marne',
      // Alsace
      'Alsace Grand Cru', 'Crémant d\'Alsace',
      // Other
      'Bandol', 'Cassis', 'Côtes de Provence', 'Cahors', 'Madiran', 'Jurançon', 'Bergerac'
    ]
  },
  'Italy': {
    regions: ['Piedmont', 'Tuscany', 'Veneto', 'Lombardy', 'Trentino-Alto Adige', 'Friuli-Venezia Giulia',
      'Emilia-Romagna', 'Umbria', 'Marche', 'Abruzzo', 'Campania', 'Puglia', 'Sicily', 'Sardinia'],
    appellations: [
      // Piedmont
      'Barolo', 'Barbaresco', 'Barbera d\'Asti', 'Barbera d\'Alba', 'Dolcetto d\'Alba',
      'Gavi', 'Roero', 'Langhe', 'Moscato d\'Asti', 'Asti',
      // Tuscany
      'Chianti', 'Chianti Classico', 'Brunello di Montalcino', 'Vino Nobile di Montepulciano',
      'Bolgheri', 'Carmignano', 'Vernaccia di San Gimignano', 'Morellino di Scansano', 'Rosso di Montalcino',
      // Veneto
      'Amarone della Valpolicella', 'Valpolicella', 'Soave', 'Prosecco', 'Bardolino', 'Lugana',
      // Other
      'Franciacorta', 'Trentino', 'Alto Adige', 'Collio', 'Friuli', 'Lambrusco',
      'Orvieto', 'Montepulciano d\'Abruzzo', 'Taurasi', 'Fiano di Avellino', 'Greco di Tufo',
      'Primitivo di Manduria', 'Negroamaro', 'Etna', 'Nero d\'Avola', 'Vermentino di Sardegna'
    ]
  },
  'Spain': {
    regions: ['Rioja', 'Ribera del Duero', 'Priorat', 'Rías Baixas', 'Rueda', 'Penedès',
      'Navarra', 'Toro', 'Jumilla', 'La Mancha', 'Jerez', 'Catalonia', 'Galicia', 'Castilla y León'],
    appellations: [
      'Rioja', 'Rioja Alta', 'Rioja Alavesa', 'Rioja Oriental', 'Ribera del Duero', 'Priorat',
      'Rías Baixas', 'Rueda', 'Toro', 'Bierzo', 'Penedès', 'Cava', 'Montsant',
      'Navarra', 'Somontano', 'Campo de Borja', 'Calatayud', 'Jumilla', 'Yecla',
      'Valdepeñas', 'La Mancha', 'Jerez-Xérès-Sherry', 'Manzanilla-Sanlúcar de Barrameda',
      'Málaga', 'Montilla-Moriles', 'Txakoli', 'Cigales', 'Arribes', 'Tierra de León'
    ]
  },
  'United States': {
    regions: ['California', 'Oregon', 'Washington', 'New York', 'Virginia', 'Texas', 'Colorado', 'Michigan'],
    appellations: [
      // California - Napa
      'Napa Valley', 'Oakville', 'Rutherford', 'St. Helena', 'Calistoga', 'Stags Leap District',
      'Howell Mountain', 'Atlas Peak', 'Diamond Mountain', 'Spring Mountain', 'Mount Veeder', 'Yountville', 'Coombsville',
      // California - Sonoma
      'Sonoma County', 'Russian River Valley', 'Sonoma Coast', 'Alexander Valley', 'Dry Creek Valley',
      'Knights Valley', 'Bennett Valley', 'Carneros', 'Chalk Hill', 'Green Valley',
      // California - Other
      'Paso Robles', 'Santa Barbara County', 'Santa Rita Hills', 'Sta. Rita Hills', 'Santa Maria Valley', 'Santa Ynez Valley',
      'Monterey', 'Santa Lucia Highlands', 'Arroyo Seco', 'Livermore Valley', 'Lodi',
      'Sierra Foothills', 'Amador County', 'El Dorado', 'Anderson Valley', 'Mendocino',
      'Central Coast', 'North Coast', 'San Luis Obispo',
      // Oregon
      'Willamette Valley', 'Dundee Hills', 'Eola-Amity Hills', 'Chehalem Mountains', 'Ribbon Ridge',
      'Yamhill-Carlton', 'McMinnville', 'Rogue Valley', 'Umpqua Valley', 'Columbia Gorge',
      // Washington
      'Columbia Valley', 'Walla Walla Valley', 'Yakima Valley', 'Red Mountain', 'Horse Heaven Hills',
      'Wahluke Slope', 'Rattlesnake Hills', 'Snipes Mountain',
      // New York
      'Finger Lakes', 'Long Island', 'North Fork of Long Island', 'Hudson River Region'
    ]
  },
  'Australia': {
    regions: ['South Australia', 'Victoria', 'New South Wales', 'Western Australia', 'Tasmania'],
    appellations: [
      'Barossa Valley', 'Eden Valley', 'Clare Valley', 'McLaren Vale', 'Adelaide Hills', 'Coonawarra',
      'Yarra Valley', 'Mornington Peninsula', 'Heathcote', 'Grampians', 'Beechworth', 'Rutherglen',
      'Hunter Valley', 'Orange', 'Mudgee', 'Riverina',
      'Margaret River', 'Great Southern', 'Swan Valley',
      'Tasmania'
    ]
  },
  'New Zealand': {
    regions: ['Marlborough', 'Hawke\'s Bay', 'Central Otago', 'Martinborough', 'Gisborne', 'Waipara', 'Nelson'],
    appellations: [
      'Marlborough', 'Hawke\'s Bay', 'Gimblett Gravels', 'Central Otago', 'Martinborough',
      'Gisborne', 'Waipara Valley', 'Nelson', 'Canterbury', 'Wairarapa'
    ]
  },
  'Argentina': {
    regions: ['Mendoza', 'San Juan', 'Salta', 'Patagonia', 'La Rioja'],
    appellations: [
      'Mendoza', 'Luján de Cuyo', 'Maipú', 'Uco Valley', 'Valle de Uco', 'Tupungato', 'San Carlos',
      'Salta', 'Cafayate', 'San Juan', 'Patagonia', 'Río Negro', 'Neuquén'
    ]
  },
  'Chile': {
    regions: ['Central Valley', 'Aconcagua', 'Coquimbo', 'Southern Regions'],
    appellations: [
      'Maipo Valley', 'Rapel Valley', 'Colchagua Valley', 'Cachapoal Valley', 'Curicó Valley',
      'Maule Valley', 'Casablanca Valley', 'San Antonio Valley', 'Leyda Valley',
      'Aconcagua Valley', 'Elqui Valley', 'Limarí Valley', 'Bío-Bío Valley'
    ]
  },
  'Portugal': {
    regions: ['Douro', 'Alentejo', 'Dão', 'Bairrada', 'Vinho Verde', 'Lisboa', 'Setúbal', 'Madeira'],
    appellations: [
      'Douro', 'Port', 'Porto', 'Alentejo', 'Dão', 'Bairrada', 'Vinho Verde',
      'Lisboa', 'Setúbal', 'Madeira', 'Tejo', 'Beira Interior'
    ]
  },
  'Germany': {
    regions: ['Mosel', 'Rheingau', 'Pfalz', 'Rheinhessen', 'Baden', 'Franken', 'Nahe', 'Ahr'],
    appellations: [
      'Mosel', 'Rheingau', 'Pfalz', 'Rheinhessen', 'Baden', 'Franken', 'Nahe', 'Ahr',
      'Württemberg', 'Sachsen', 'Saale-Unstrut', 'Mittelrhein'
    ]
  },
  'Austria': {
    regions: ['Wachau', 'Kremstal', 'Kamptal', 'Burgenland', 'Styria', 'Vienna'],
    appellations: [
      'Wachau', 'Kremstal', 'Kamptal', 'Wagram', 'Traisental', 'Weinviertel',
      'Neusiedlersee', 'Leithaberg', 'Mittelburgenland', 'Südburgenland',
      'Südsteiermark', 'Weststeiermark', 'Vulkanland Steiermark', 'Wien'
    ]
  },
  'South Africa': {
    regions: ['Stellenbosch', 'Paarl', 'Franschhoek', 'Constantia', 'Swartland', 'Walker Bay', 'Elgin'],
    appellations: [
      'Stellenbosch', 'Paarl', 'Franschhoek', 'Constantia', 'Swartland', 
      'Walker Bay', 'Hemel-en-Aarde', 'Elgin', 'Robertson', 'Worcester', 
      'Durbanville', 'Tulbagh', 'Elim', 'Cape South Coast'
    ]
  }
};

export const WINE_COUNTRIES = [
  'Argentina', 'Australia', 'Austria', 'Chile', 'France', 'Germany', 'Greece',
  'Hungary', 'Israel', 'Italy', 'Lebanon', 'New Zealand', 'Portugal', 'South Africa',
  'Spain', 'Switzerland', 'United States', 'Uruguay'
].sort();

export const COMMON_VARIETALS = [
  // Red
  'Cabernet Sauvignon', 'Merlot', 'Pinot Noir', 'Syrah', 'Shiraz', 'Zinfandel',
  'Malbec', 'Grenache', 'Tempranillo', 'Sangiovese', 'Nebbiolo', 'Barbera',
  'Cabernet Franc', 'Petit Verdot', 'Mourvèdre', 'Carménère', 'Petite Sirah',
  'Gamay', 'Primitivo', 'Montepulciano', 'Nero d\'Avola', 'Touriga Nacional',
  'Aglianico', 'Corvina', 'Dolcetto', 'Graciano', 'Mencía', 'Tannat',
  // White
  'Chardonnay', 'Sauvignon Blanc', 'Riesling', 'Pinot Grigio', 'Pinot Gris',
  'Gewürztraminer', 'Viognier', 'Chenin Blanc', 'Sémillon', 'Moscato',
  'Albariño', 'Grüner Veltliner', 'Torrontés', 'Verdejo', 'Vermentino',
  'Marsanne', 'Roussanne', 'Trebbiano', 'Garganega', 'Fiano', 'Cortese',
  'Muscadet', 'Picpoul', 'Godello', 'Falanghina', 'Arneis', 'Greco',
  // Blends
  'Bordeaux Blend', 'Rhône Blend', 'GSM Blend', 'Meritage', 'Red Blend', 'White Blend',
  'Champagne Blend', 'Port Blend', 'Super Tuscan Blend'
].sort();

// Helper functions to get all regions and appellations
export function getAllRegions(): string[] {
  const regions: string[] = [];
  Object.values(WINE_REGIONS).forEach(country => {
    regions.push(...country.regions);
  });
  return [...new Set(regions)].sort();
}

export function getAllAppellations(): string[] {
  const appellations: string[] = [];
  Object.values(WINE_REGIONS).forEach(country => {
    appellations.push(...country.appellations);
  });
  return [...new Set(appellations)].sort();
}

export function getRegionsForCountry(country: string): string[] {
  return WINE_REGIONS[country]?.regions || [];
}

export function getAppellationsForCountry(country: string): string[] {
  return WINE_REGIONS[country]?.appellations || [];
}
